import isNil from "lodash/isNil";
import { List, Map } from "immutable";

import { EMPTY_MAP } from "app/app.constants";
import { ACTIONS } from "features/planner/planner.constants";
import { CardCompetencyStatusMapper } from "features/planner/planner.mappers";

const initialState = EMPTY_MAP.set("summarized", EMPTY_MAP);

export default (state = initialState, action) => {
  const { type, payload, error } = action;

  switch (type) {
    case ACTIONS.GET_GROUP_CARDS_SUMMARIZED_COMPETENCY_STATUS: {
      if (error) return state;

      const { groupId } = action;

      return state.setIn(
        ["summarized", groupId.toString()],
        Map(
          List(payload).map(cardCompetencyStatus => [
            cardCompetencyStatus.cardId.toString(),
            CardCompetencyStatusMapper.from(cardCompetencyStatus),
          ]),
        ),
      );
    }

    case ACTIONS.GET_VIEW_COMPETENCY_STATUSES: {
      if (error) return state;

      return state.set(
        "summarized",
        payload.reduce(
          (result, cardCompetencyStatus) =>
            result.setIn(
              [
                cardCompetencyStatus.groupId.toString(),
                cardCompetencyStatus.cardId.toString(),
              ],
              CardCompetencyStatusMapper.from(cardCompetencyStatus),
            ),
          EMPTY_MAP,
        ),
      );
    }

    case ACTIONS.CREATE_CARD_MOVE: {
      if (error) return state;

      const {
        cardId,
        sourceGroupId,
        targetCardContainerId,
        sourceCardContainerId,
      } = action;

      if (targetCardContainerId === sourceCardContainerId) return state;

      return state.deleteIn([
        "summarized",
        sourceGroupId.toString(),
        cardId.toString(),
      ]);
    }

    case ACTIONS.GET_CARD_MISSING_COMPETENCY_STATUS_ITEMS_FOR_GROUP: {
      if (error) return state;

      const { groupId, cardId } = action;

      const {
        specificationCompetencyStatuses,
        summarizedSpecificationCompetencyStatus,
      } = payload;

      return state
        .setIn(
          ["byGroupAndCardId", groupId.toString(), cardId.toString()],
          List(specificationCompetencyStatuses).map(
            CardCompetencyStatusMapper.from,
          ),
        )
        .updateIn(
          ["summarized", groupId.toString(), cardId.toString()],
          status =>
            isNil(summarizedSpecificationCompetencyStatus)
              ? status
              : summarizedSpecificationCompetencyStatus,
        );
    }

    default: {
      return state;
    }
  }
};
